export async function postForm(endpoint, payload) {
  if (!endpoint) {
    throw new Error("Form endpoint is not configured.");
  }

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "omit",
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Form request failed with status ${response.status}.`);
  }

  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get("content-type") || "";
  return contentType.includes("application/json") ? response.json() : null;
}

export function isFormEnabled(flagName, endpoint) {
  return process.env[flagName] === "true" && Boolean(endpoint);
}
